import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689a8022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"white-space":"pre-wrap"} }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "產生圖像中...", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = { class: "ion-text-center ion-margin-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.title)
              ? (_openBlock(), _createBlock(_component_ion_title, {
                  key: 0,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareCanvasImg()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.shareSocialOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.loadingCanvas]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        (_ctx.loadingCanvas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ion_spinner),
              _hoisted_3
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_stage, {
                ref: "stageRef",
                config: { width: _ctx.sceneWidth, height: _ctx.sceneHeight },
                onMousedown: _ctx.handleStageMouseDown,
                onTouchstart: _ctx.handleStageMouseDown
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layer, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_image, {
                        config: {
            width: _ctx.sceneWidth,
            height: _ctx.sceneHeight,
            x: 0,
            y: 0,
            image: _ctx.canvas.bgImg
          }
                      }, null, 8, ["config"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_layer, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_image, {
                        config: {
            scaleX: Math.min(75 / _ctx.canvas.petImg.naturalWidth, 200 / _ctx.canvas.petImg.naturalHeight),
            scaleY: Math.min(75 / _ctx.canvas.petImg.naturalWidth, 200 / _ctx.canvas.petImg.naturalHeight),
            x: _ctx.sceneWidth / 2 - 75 / 2,
            y: _ctx.sceneHeight / 2 - 120,
            image: _ctx.canvas.petImg
          }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 25,
              y: _ctx.sceneHeight / 2 + 30,
              width: _ctx.sceneWidth / 2,
              height: _ctx.canvas.fontSize,
              text: `名字：${_ctx.userPet.lostPetPosterName}`,
              fontSize: _ctx.canvas.fontSize,
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: _ctx.sceneWidth / 2,
              y: _ctx.sceneHeight / 2 + 30,
              width: _ctx.sceneWidth / 2,
              height: _ctx.canvas.fontSize,
              text: `品種：${_ctx.userPet.lostPetPosterBreed}`,
              fontSize: _ctx.canvas.fontSize,
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 25,
              y: _ctx.sceneHeight / 2 + 55,
              width: _ctx.sceneWidth,
              height: _ctx.canvas.fontSize,
              text: `年齡：${_ctx.getPetAge(_ctx.pet.dateOfBirth)} (${_ctx.pet.gender == 'male' ? '男' : '女'}${_ctx.pet.color ? ' / ' + _ctx.pet.color : ''})`,
              fontSize: _ctx.canvas.fontSize,
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 25,
              y: _ctx.sceneHeight / 2 + 80,
              width: _ctx.posterContentWidth,
              height: _ctx.canvas.fontSize,
              text: `走失地點：${_ctx.userPet.lostLocation}`,
              fontSize: _ctx.canvas.fontSize,
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 25,
              y: _ctx.sceneHeight / 2 + 105,
              width: _ctx.posterContentWidth,
              height: _ctx.canvas.fontSize,
              text: `特徵：${_ctx.userPet.remarkFeatures}`,
              fontSize: _ctx.canvas.fontSize,
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_rect, {
                        config: {
            x: 45,
            y: _ctx.sceneHeight - 65,
            width: _ctx.posterContentWidth - 45,
            height: 50,
            fill: '#E41D3E',
          }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 20,
              y: _ctx.sceneHeight - 60,
              width: _ctx.posterContentWidth,
              height: 20,
              text: `聯絡電話：${_ctx.userPet.contactPersonPhone}`,
              fontSize: 20,
              align: 'center',
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
              fill: 'white',
            }
                      }, null, 8, ["config"]),
                      _createVNode(_component_v_text, {
                        config: {
              x: 20,
              y: _ctx.sceneHeight - 38,
              width: _ctx.posterContentWidth,
              height: 20,
              text: `${_ctx.userPet.contactPersonName}`,
              fontSize: 20,
              align: 'center',
              verticalAlign: 'middle',
              fontFamily: 'Calibri',
              fill: 'white',
            }
                      }, null, 8, ["config"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["config", "onMousedown", "onTouchstart"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ion_button, {
                  color: "secondary",
                  shape: "round",
                  fill: "outline",
                  target: "_blank",
                  onClick: _ctx.saveCanvasImg
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 儲存圖片 "),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.downloadOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("寵物名字")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "text",
                        modelValue: _ctx.userPet.lostPetPosterName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userPet.lostPetPosterName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("寵物品種")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "text",
                        modelValue: _ctx.userPet.lostPetPosterBreed,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userPet.lostPetPosterBreed) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("走失地點")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "text",
                        modelValue: _ctx.userPet.lostLocation,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userPet.lostLocation) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("特徵描述")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_textarea, {
                        modelValue: _ctx.userPet.remarkFeatures,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userPet.remarkFeatures) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("聯絡電話")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "text",
                        modelValue: _ctx.userPet.contactPersonPhone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userPet.contactPersonPhone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { fill: "outline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("聯絡人名字")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "text",
                        modelValue: _ctx.userPet.contactPersonName,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userPet.contactPersonName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ion_button, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.syncPosterInfoToUserPet())),
                  expand: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('save')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    })
  ], 64))
}